import { ReactNode } from "react";
import { Box, BoxProps, Typography, TypographyProps } from "@mui/material";
import styles from "./index.module.css";
import NoResults from "./images/no-results.svg?react";
import NoResultsVariant from "./images/no-results2.svg?react";
import NoResultsNoPlus from "./images/no-results-no-plus.svg?react";
import Failed from "./images/failed.svg?react";
import NoFiles from "./images/no-files.svg?react";

export type CoreNoResultsTextProps = BoxProps & {
	header: ReactNode;
	slotProps?: {
		header: TypographyProps;
	};
};

export type CoreNoResultsProps = BoxProps & {
	variant?: "no-results" | "no-results-variant" | "no-results-no-plus" | "failed" | "no-files";
	header: ReactNode;
	image?: ReactNode;
	headerVariant?: TypographyProps["variant"];
};

export function CoreNoResultsText({ header, slotProps, children, ...boxProps }: CoreNoResultsTextProps) {
	return (
		<Box {...boxProps} className={`${styles.noResultsText} ${boxProps?.className ?? ""}`}>
			<Typography
				variant={slotProps?.header?.variant ?? "h3"}
				{...slotProps?.header}
				sx={{
					fontSize: 20,
					fontWeight: 600,
					color: "black",
					...slotProps?.header?.sx,
				}}
			>
				{header}
			</Typography>
			{children}
		</Box>
	);
}

export default function CoreNoResults({
	variant = "no-results",
	header,
	headerVariant,
	image,
	gap = "min(40px, 6%)",
	className,
	children,
	...boxProps
}: CoreNoResultsProps) {
	let defaultImage;
	switch (variant) {
		case "no-results":
			defaultImage = <NoResults style={{ maxWidth: "60%" }} />;
			break;
		case "no-results-variant":
			defaultImage = <NoResultsVariant style={{ maxWidth: "60%" }} />;
			break;
		case "failed":
			defaultImage = <Failed style={{ maxWidth: "60%" }} />;
			break;
		case "no-results-no-plus":
			defaultImage = <NoResultsNoPlus style={{ maxWidth: "60%" }} />;
			break;
		case "no-files":
			defaultImage = <NoFiles style={{ maxWidth: "60%" }} />;
			break;
	}

	return (
		<Box {...boxProps} gap={gap} className={`${styles.noResults} ${className || ""}`}>
			{image || defaultImage}
			<CoreNoResultsText header={header} slotProps={{ header: { variant: headerVariant } }}>
				{children}
			</CoreNoResultsText>
		</Box>
	);
}
